export const CHARGER_IMAGE = 'https://d2puadiodsdamo.cloudfront.net/optech-demo/charger-620-front.png';

export const PRICING_CHART_IMAGE = 'https://d2puadiodsdamo.cloudfront.net/optech-demo/pricing-chart.jpg';